import { Nullable, Project, ProjectKind } from "@/types";

/** InstallationTypes::RETROFIT in the CRM. */
export const RETROFIT_INSTALLATION_TYPE = 6;

const FINISHED = 2;

export function isWorkProject(project?: Partial<Project> | null): boolean {
    return project?.isWorkProject === true;
}

/** Afgerond freezes a classic project. A werkproject's status is free, so it never freezes. */
export function isFinishedLock(project?: Partial<Project> | null): boolean {
    return project?.status === FINISHED && !isWorkProject(project);
}

/** A classic project's Gepland-only fields freeze once it leaves Gepland; a werkproject's never do. */
export function isPastPlannedLock(project?: Partial<Project> | null): boolean {
    return (project?.status ?? 0) > 0 && !isWorkProject(project);
}

/** WerkprojectFence::satisfied() in the CRM: a serviceproject, or an installatieproject on Retrofit. */
export function werkprojectFenceSatisfied(
    kind: Nullable<ProjectKind> | undefined,
    installationType: Nullable<number> | undefined
): boolean {
    return kind === "service" || installationType === RETROFIT_INSTALLATION_TYPE;
}
